export function initVideoModalBlocks() {
	const blocks = document.querySelectorAll('[data-video-modal-block]');
	if (!blocks.length) {
		return;
	}

	blocks.forEach((block) => {
		initVideoModalBlock(block);
	});
}

function initVideoModalBlock(block) {
	const modal = block.querySelector('[data-video-modal]');
	const video = modal ? modal.querySelector('[data-video-element]') : null;
	const iframe = modal ? modal.querySelector('[data-video-iframe]') : null;
	const triggers = Array.from(block.querySelectorAll('[data-video-trigger]'));
	if (!modal || !video || !iframe || !triggers.length) {
		return;
	}

	let isOpen = false;

	const open = (rawUrl) => {
		const source = resolveVideoSource(rawUrl);
		if (!source) {
			return;
		}

		if (source.type === 'embed') {
			video.pause();
			video.removeAttribute('src');
			video.load();
			video.hidden = true;

			iframe.src = source.src;
			iframe.hidden = false;
		} else {
			iframe.src = '';
			iframe.hidden = true;

			video.src = source.src;
			video.hidden = false;
			const playPromise = video.play();
			if (playPromise && typeof playPromise.catch === 'function') {
				playPromise.catch(() => undefined);
			}
		}

		modal.hidden = false;
		document.body.style.overflow = 'hidden';
		isOpen = true;
	};

	const close = () => {
		video.pause();
		video.removeAttribute('src');
		video.load();
		video.hidden = true;

		iframe.src = '';
		iframe.hidden = true;

		modal.hidden = true;
		document.body.style.overflow = '';
		isOpen = false;
	};

	triggers.forEach((trigger) => {
		trigger.addEventListener('click', () => {
			const url = trigger.getAttribute('data-video-url') || '';
			open(url);
		});
	});

	modal.querySelectorAll('[data-video-close]').forEach((control) => {
		control.addEventListener('click', close);
	});

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape' && isOpen) {
			close();
		}
	});
}

function resolveVideoSource(rawUrl) {
	const url = String(rawUrl || '').trim();
	if (!url) {
		return null;
	}

	const youtube = parseYouTube(url);
	if (youtube) {
		return { type: 'embed', src: youtube };
	}

	const vimeo = parseVimeo(url);
	if (vimeo) {
		return { type: 'embed', src: vimeo };
	}

	return { type: 'file', src: url };
}

function parseYouTube(rawUrl) {
	let parsed;
	try {
		parsed = new URL(rawUrl);
	} catch (error) {
		return '';
	}

	const host = parsed.hostname.replace(/^www\./, '');
	let id = '';

	if (host === 'youtu.be') {
		id = parsed.pathname.replace(/^\/+/, '').split('/')[0] || '';
	} else if (host === 'youtube.com' || host === 'm.youtube.com') {
		if (parsed.pathname === '/watch') {
			id = parsed.searchParams.get('v') || '';
		} else if (parsed.pathname.startsWith('/embed/')) {
			id = parsed.pathname.split('/')[2] || '';
		} else if (parsed.pathname.startsWith('/shorts/')) {
			id = parsed.pathname.split('/')[2] || '';
		}
	}

	if (!id) {
		return '';
	}

	return `https://www.youtube.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0&modestbranding=1`;
}

function parseVimeo(rawUrl) {
	let parsed;
	try {
		parsed = new URL(rawUrl);
	} catch (error) {
		return '';
	}

	const host = parsed.hostname.replace(/^www\./, '');
	if (host !== 'vimeo.com' && host !== 'player.vimeo.com') {
		return '';
	}

	const parts = parsed.pathname.split('/').filter(Boolean);
	const id = parts.find((part) => /^\d+$/.test(part)) || '';
	if (!id) {
		return '';
	}

	return `https://player.vimeo.com/video/${encodeURIComponent(id)}?autoplay=1`;
}
